import * as z from 'zod';
import { LoginFormValues } from './types';
import { schema } from '@forms/helpers';

export const formSchema = z.object({
  email: schema.input({ name: 'email', type: 'email', required: true }),
  password: schema.input({ name: 'password', required: true }),
});

export const defaultValues: LoginFormValues = {
  email: '',
  password: '',
};
